import { IScaffoldActionSetDragging, ScaffoldState } from "./interface";

/**
 * Handles the SET_DRAGGING action by updating the isDragging flag on the scaffold state.
 *
 * @param action - The SET_DRAGGING action carrying the new drag state.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with isDragging set to the value from the action.
 */
export const scr_setDragging = <T>(
  action: IScaffoldActionSetDragging,
  state: ScaffoldState<T>,
): ScaffoldState<T> => ({
  ...state,
  isDragging: action.isDragging,
});
